/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : LinkedTestCaseComponent.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { componentStyle } from "../../../config/appTheme";
import CustomSearchFilterV2 from "../../../components/customComponentsV2/common/searchBar/CustomSearchFilterV2";
import CustomDataGridV2 from "../../../components/customComponentsV2/common/datagrid/CustomDataGridV2";

function LinkedTestCaseComponent({ linkedTestCases = [] }) {
  const [filteredTestCaseList, setFilteredTestCaseList] = useState([]);
  const [allFilteredData, setAllFilteredData] = useState([]);
  const [page, setPage] = useState(1);

  const COLUMN = [
    {
      field: "serialNumber",
      headerName: "S.No",
      flex: 0.5,
    },
    {
      field: "test_case_id",
      headerName: "Test Case ID",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Test Case Name",
      flex: 1,
    },
    {
      field: "need_new_vehicle",
      headerName: "Need New Vehicle",
      flex: 1,
    },
  ];
  return (
    <Box>
      <Grid container>
        <Grid item sm={12}>
          <Box sx={{ display: "flex", gap: 1, mt: 1, alignItems: "center" }}>
            <Typography sx={{ ...componentStyle.font.cardText }}>
              Test Cases:
            </Typography>
            <Box sx={{ width: "250px" }}>
              <CustomSearchFilterV2
                placeholder="Search"
                searchKeys={["test_case_id", "name"]}
                getDataOnSearch={(filteredData) => {
                  if (!filteredData || !Array.isArray(filteredData)) {
                    setFilteredTestCaseList([]);
                    setAllFilteredData([]);
                    return;
                  }
                  setAllFilteredData(filteredData);
                  const startIndex = (page - 1) * 25;
                  const paginatedData = filteredData
                    .slice(startIndex, startIndex + 25)
                    .map((item, index) => {
                      return {
                        ...item,
                        id: item.test_case_id,
                        need_new_vehicle: item.need_new_vehicle ? "Yes" : "No",
                        test_case_id: item.test_case_id.toString(),
                        name: item.name.toString(),
                        serialNumber: startIndex + index + 1,
                      };
                    });

                  setFilteredTestCaseList(paginatedData);
                }}
                inputData={linkedTestCases}
              />
            </Box>
          </Box>
        </Grid>
        <Grid sm={12} sx={{ pr: 1 }}>
          <Box sx={{ height: "350px", mt: 1 }}>
            <CustomDataGridV2
              rows={filteredTestCaseList}
              columns={COLUMN}
              rowsPerPage={25}
              page={page}
              showPagination={true}
              totalItems={allFilteredData.length}
              handlePageChange={(pageNo) => {
                setPage(pageNo);
                const startIndex = (pageNo - 1) * 25;
                const paginatedData = allFilteredData
                  .slice(startIndex, startIndex + 25)
                  .map((item, index) => {
                    return {
                      ...item,
                      id: item.test_case_id,
                      test_case_id: item.test_case_id.toString(),
                      name: item.name.toString(),
                      serialNumber: startIndex + index + 1,
                    };
                  });
                setFilteredTestCaseList(paginatedData);
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default LinkedTestCaseComponent;
